/* custom.js — Vanilla JS (Phase B Migration)
 * Rewritten from jQuery to zero dependencies.
 * Script loaded with defer, so DOM is ready when this runs.
 */

(function () {
  'use strict';

  // ---- Helper: delegated event listener ----
  function on(event, selector, handler, parent) {
    (parent || document).addEventListener(event, function (e) {
      var target = e.target.closest(selector);
      if (target && (parent || document).contains(target)) {
        handler.call(target, e);
      }
    });
  }

  // ---- Collection Page: Filters & Sorting ----
  if (document.body.classList.contains('template-collection')) {
    var filtersToolbar = document.querySelector('.filters-toolbar');
    if (filtersToolbar) {
      var items = filtersToolbar.querySelectorAll('.filters-toolbar__item-child');
      var sortSelect = items[0];

      // Fetch collections list
      fetch('/collections.json')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var collections = data.collections;
          var html = '';
          for (var i = 0; i < collections.length; i++) {
            html += '<li><a href="/collections/' + collections[i].handle + '">' + collections[i].title + '</a></li>';
          }
          if (window.location.pathname !== '/') {
            var activeLink = document.querySelector('a[href="' + window.location.pathname + '"]');
            if (activeLink) activeLink.parentElement.classList.add('selected');
          } else {
            var defaultLink = document.querySelector('a[href="/collections/full-packs"]');
            if (defaultLink) defaultLink.parentElement.classList.add('selected');
          }
        })
        .catch(function () {});

      // Build sort filter dropdown
      var sortHTML = '';
      if (sortSelect) {
        sortSelect.querySelectorAll('option:not([disabled])').forEach(function (option) {
          var val = option.getAttribute('value');
          if (val === 'title-ascending' || val === 'title-descending' || val === 'manual') return;
          if (option.getAttribute('selected') === 'selected') {
            sortHTML += '<li class="selected" data-value="' + val + '">' + option.textContent + '</li>';
          } else {
            sortHTML += '<li data-value="' + val + '">' + option.textContent + '</li>';
          }
        });
      }

      // Inject HTML into custom filter dropdowns
      var sortUl = document.querySelector('.filters-custom .filter-sort ul');
      if (sortUl) sortUl.innerHTML = sortHTML;

      var sortSpan = document.querySelector('.filters-custom .filter-sort span');
      var sortSelectedLi = document.querySelector('.filters-custom .filter-sort ul li.selected');
      if (sortSpan && sortSelectedLi) sortSpan.innerHTML = sortSelectedLi.innerHTML;

      // Toggle filter dropdowns open/closed
      on('click', '.filters-custom > div > span', function () {
        document.querySelectorAll('.filters-custom .filter').forEach(function (f) { f.classList.remove('opened'); });
        this.parentElement.classList.toggle('opened');
      });

      // Close filters on outside click
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.filters-custom > div.filter')) {
          document.querySelectorAll('.filters-custom > div.filter').forEach(function (f) { f.classList.remove('opened'); });
        }
      });

      // Filter item click (sort)
      on('click', '.filters-custom .filter-sort ul li', function () {
        this.parentElement.querySelectorAll('li').forEach(function (li) { li.classList.remove('selected'); });
        this.classList.add('selected');
        var value = this.getAttribute('data-value');
        var fSortSpan = document.querySelector('.filters-toolbar .filters-custom .filter-sort span');
        if (fSortSpan) fSortSpan.textContent = this.textContent;
        var sortBy = document.querySelector('#SortBy');
        var li = this;
        setTimeout(function () {
          if (sortBy) {
            sortBy.value = value;
            sortBy.dispatchEvent(new Event('change'));
          }
          var parentFilter = li.closest('.filter');
          if (parentFilter) parentFilter.classList.remove('opened');
        }, 500);
      });

      // Store collection info in localStorage
      localStorage.removeItem('collection-link');
      localStorage.removeItem('collection-title');
      var selectedCollLink = document.querySelector('.collections-list .selected a');
      if (selectedCollLink) {
        localStorage.setItem('collection-link', selectedCollLink.getAttribute('href'));
        localStorage.setItem('collection-title', selectedCollLink.textContent);
      }
    }

    // Swiper carousel for collection banner
    if (typeof Swiper !== 'undefined') {
      new Swiper('.collection_banner_slider', {
        loop: true,
        slidesPerView: 2,
        spaceBetween: 10,
        centeredSlides: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          768: { slidesPerView: 3, spaceBetween: 20 },
          1024: { slidesPerView: 4, spaceBetween: 30 },
        },
      });
    }

    // Category filter toggle
    on('click', '.filter-categories', function () {
      this.classList.toggle('active');
      var list = document.querySelector('.collections-list');
      if (list) list.classList.toggle('active');
      var open = this.classList.contains('active');
      var span = this.querySelector('span');
      if (span) span.textContent = open ? 'Close' : 'Categories';
      // The button is a disclosure for a full-viewport drawer; without this it
      // announced no state at all, and the visible word was the only signal.
      this.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // ---- Product Page ----
  if (document.body.classList.contains('template-product')) {
    // Breadcrumbs from localStorage
    var collLink = document.querySelector('.product-breadcrumbs .collection-link');
    if (collLink) {
      collLink.setAttribute('href', localStorage.getItem('collection-link') || '');
      collLink.textContent = localStorage.getItem('collection-title') || '';
    }
    var headerNavLink = document.querySelector('header ul.site-nav li:first-child a');
    var storeLink = document.querySelector('.product-breadcrumbs a.store-link');
    if (headerNavLink && storeLink) {
      storeLink.setAttribute('href', headerNavLink.getAttribute('href'));
    }

    var singleOptionSelector = document.querySelector('#SingleOptionSelector-0');

    // Move streamlabs element before product video
    var productVideo = document.querySelector('.product_video');
    var streamlabsEl = document.getElementById('streamlabs');
    if (productVideo && streamlabsEl) {
      productVideo.parentElement.insertBefore(streamlabsEl, productVideo);
    }

    // Kudos-select custom variant dropdown
    var kudosSelect = document.querySelector('.kudos-select');
    if (kudosSelect && singleOptionSelector) {
      var lis = kudosSelect.querySelectorAll('li');
      var priceItem = document.querySelector('.product-single .product__price .price-item');
      var currencySymbol = priceItem ? priceItem.textContent.charAt(0) : '$';

      lis.forEach(function (li) {
        var name = li.getAttribute('data-name');
        var price = parseInt(li.getAttribute('data-price')) / 100;
        li.innerHTML = name + ' - ' + currencySymbol + price;
      });

      var selectedLi = lis[singleOptionSelector.selectedIndex];
      if (selectedLi) {
        selectedLi.classList.add('selected');
        var ksSpan = kudosSelect.querySelector(':scope > span');
        if (ksSpan) ksSpan.style.width = getComputedStyle(selectedLi).width;
      }

      on('click', '.kudos-select li', function () {
        kudosSelect.querySelectorAll('li').forEach(function (li) { li.classList.remove('selected'); });
        this.classList.add('selected');
        var index = Array.from(this.parentElement.children).indexOf(this);
        var left;
        if (index === 0) {
          left = 4;
        } else if (index === 1) {
          left = parseInt(getComputedStyle(kudosSelect).width) - parseInt(getComputedStyle(this).width) - 5;
        }
        var span = kudosSelect.querySelector(':scope > span');
        if (span) {
          span.style.width = getComputedStyle(this).width;
          if (left !== undefined) span.style.left = left + 'px';
        }
        var varName = this.textContent.split(' - ')[0];
        singleOptionSelector.value = varName;
        singleOptionSelector.dispatchEvent(new Event('change'));
      });

      setTimeout(function () {
        var li = lis[singleOptionSelector.selectedIndex];
        if (li) li.click();
      }, 100);

      setTimeout(function () {
        var span = kudosSelect.querySelector(':scope > span');
        if (span) span.classList.add('visible');
      }, 200);

      window.addEventListener('resize', function () {
        var activeLi = lis[singleOptionSelector.selectedIndex];
        if (activeLi) {
          var span = kudosSelect.querySelector(':scope > span');
          if (span) {
            span.style.width = getComputedStyle(activeLi).width;
            span.style.left = (parseInt(getComputedStyle(kudosSelect).width) - parseInt(getComputedStyle(activeLi).width) - 5) + 'px';
          }
        }
      });
    }

    // Video setup popup (YouTube embed)
    on('click', '.product__setup button[data-link]', function () {
      var link = this.getAttribute('data-link');
      if (link.indexOf('youtu.be') > -1) {
        var popupInner = document.querySelector('.pi-popup .pi-popup_inner');
        if (popupInner) {
          popupInner.innerHTML =
            '<div class="videoWrapper"><iframe src="https://www.youtube.com/embed/' +
            link.split('youtu.be/')[1] +
            '"></iframe></div><div class="popup-close"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="black"/></svg></div>';
        }
        var popup = document.querySelector('.pi-popup');
        if (popup) popup.classList.add('on-screen');
      }
    });

    on('click', '.pi-popup .popup-close', function () {
      var popup = document.querySelector('.pi-popup');
      if (popup) popup.classList.remove('on-screen');
      var inner = document.querySelector('.pi-popup .pi-popup_inner');
      if (inner) inner.innerHTML = '';
    });

    document.addEventListener('mouseup', function (e) {
      var inner = document.querySelector('.pi-popup_inner');
      if (inner && !inner.contains(e.target)) {
        var popup = document.querySelector('.pi-popup');
        if (popup) popup.classList.remove('on-screen');
        inner.innerHTML = '';
      }
    });

    // Product tags dynamic linking
    var productTags = document.querySelector('.product-tags');
    if (productTags) {
      var savedCollLink = localStorage.getItem('collection-link') || '';
      var collHandle = savedCollLink.split('/')[2] || '';
      productTags.querySelectorAll('span').forEach(function (span) {
        var a = span.querySelector('a');
        if (a) {
          var tagPart = a.getAttribute('href').split('/')[3] || '';
          a.setAttribute('href', '/collections/' + collHandle + '/' + tagPart);
        }
      });
    }

    // Product video banner (YouTube embed on click)
    var videoBannerContainer = document.querySelector('.product_video__banner_container');
    if (videoBannerContainer) {
      var playButton = document.querySelector('.product_video__play');
      var bannerImage = document.querySelector('.product_video__banner_image');
      var contentEl = document.querySelector('.product_video__content');
      if (playButton && contentEl) {
        var videoUrl = contentEl.dataset.url;
        playButton.addEventListener('click', function () {
          videoBannerContainer.innerHTML = '<iframe width="100%" height="100%" src="' + videoUrl + '?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
          playButton.style.display = 'none';
          if (bannerImage) bannerImage.style.display = 'none';
        });
      }
    }

    // Checkout redirect
    on('click', '#to_checkout', function (e) {
      e.preventDefault();
      var variantSelect = document.querySelector('#ProductSelect-product-template');
      if (variantSelect) {
        window.location.href = window.location.origin + '/cart/' + variantSelect.value + ':1';
      }
    });
  }

  // ---- Orders Page ----
  if (document.body.classList.contains('template-customers-order')) {
    var placedAt = document.querySelector('.placed_at');
    var placedHidden = document.querySelector('.placed-hidden');
    if (placedAt && placedHidden) placedAt.innerHTML = placedHidden.innerHTML;
  }

  // ---- Search Page: Hide Policy Pages ----
  if (document.body.classList.contains('template-search')) {
    document.querySelectorAll('.product-card').forEach(function (card) {
      var title = card.querySelector('.product-card__title');
      if (title) {
        var text = title.textContent;
        if (text === 'Privacy Policy' || text === 'Terms & Conditions' || text === 'Cookie Policy') {
          var gridItem = card.closest('.grid__item');
          if (gridItem) gridItem.style.display = 'none';
        }
      }
    });
  }

  // ---- Mobile Search Toolbar ----
  if (window.innerWidth < 750) {
    var searchForm = document.querySelector('.search-toolbar form');
    if (searchForm) {
      searchForm.addEventListener('click', function () {
        this.classList.add('search-opened');
      });
      document.addEventListener('mouseup', function (e) {
        if (searchForm && !searchForm.contains(e.target)) {
          searchForm.classList.remove('search-opened');
        }
      });
    }
  }

  // ---- Wishlist (iWish) ----
  if (document.querySelector('.iwishProducts')) {
    document.querySelectorAll('.iwishItem').forEach(function (item) {
      var form = item.querySelector('form');
      if (form) {
        form.insertAdjacentHTML('beforeend', '<div class="wishButtons"><div class="remove"></div><div class="add-to-cart"></div></div>');
      }
    });
    on('click', '.wishButtons .remove', function () {
      var removeBtn = this.closest('form').querySelector('.iwishMeta .iwishRemoveBtn');
      if (removeBtn) removeBtn.click();
    });
    on('click', '.wishButtons .add-to-cart', function () {
      var buyBtn = this.closest('form').querySelector('.iwishMeta .iwishBuyBtn');
      if (buyBtn) buyBtn.click();
    });
  }

  // ---- FAQ Accordion ----
  on('click', '.faq__title_container', function () {
    var parent = this.parentElement;
    var content = this.nextElementSibling;
    parent.classList.toggle('active');
    if (content) {
      content.style.display = parent.classList.contains('active') ? 'block' : 'none';
    }
  });

  // ---- Video on Hover (Product Cards) ----
  // Using mouseover/mouseout for delegation (mouseenter/mouseleave don't bubble)
  document.addEventListener('mouseover', function (e) {
    var target = e.target.closest('.grid-view-item');
    if (target && (!e.relatedTarget || !target.contains(e.relatedTarget))) {
      var video = target.querySelector('.grid-view-item__video');
      if (video) video.play();
    }
  });
  document.addEventListener('mouseout', function (e) {
    var target = e.target.closest('.grid-view-item');
    if (target && (!e.relatedTarget || !target.contains(e.relatedTarget))) {
      var video = target.querySelector('.grid-view-item__video');
      if (video) video.pause();
    }
  });

  // ---- To Top Button ----
  var toTopButton = document.querySelector('.toTop');
  if (toTopButton) {
    var toTopTicking = false;
    window.addEventListener('scroll', function () {
      if (!toTopTicking) {
        requestAnimationFrame(function() {
          if (window.pageYOffset > 100) {
            toTopButton.classList.add('active');
          } else {
            toTopButton.classList.remove('active');
          }
          toTopTicking = false;
        });
        toTopTicking = true;
      }
    });
  }

  // ---- Products Per Page ----
  function setProductsPerPage(value) {
    var body = new URLSearchParams();
    body.append('attributes[pagination]', value);
    fetch('/cart.js', {
      method: 'POST',
      body: body
    })
      .then(function () { window.location.reload(); })
      .catch(function () {});
  }

  on('click', '.limited-view .dropdown-menu span', function () {
    setProductsPerPage(this.getAttribute('data-value'));
  });

  on('click', '.limited-view label', function () {
    var next = this.nextElementSibling;
    if (next) next.classList.toggle('active');
  });

  // ---- Password Show/Hide ----
  on('click', '.show_pass', function () {
    var input = this.nextElementSibling;
    if (input) {
      input.type = input.type === 'password' ? 'text' : 'password';
    }
  });

  // ---- Cart Popup System ----
  var cartDrawer = document.querySelector('.cart-popup-wrapper');
  var moneyFmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  var lastCompareAtSubtotal = 0;

  var getCart = async function () {
    try {
      var response = await fetch('/cart.js', {
        method: 'GET',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
      });
      return await response.json();
    } catch (error) {}
  };

  var getProductByHandle = async function (handle) {
    try {
      var response = await fetch('/products/' + handle + '.js', {
        method: 'GET',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
      });
      return await response.json();
    } catch (error) {}
  };

  var buildCart = async function (el) {
    var cartData = await getCart();
    var cartInnerContent = document.querySelector('.cart_popup__inner_content');
    if (cartInnerContent) cartInnerContent.innerHTML = '';

    // Batch-fetch all product data in parallel
    var uniqueHandles = [];
    var seen = {};
    for (var i = 0; i < cartData.items.length; i++) {
      var h = cartData.items[i].handle;
      if (!seen[h]) { seen[h] = true; uniqueHandles.push(h); }
    }
    var productResults = await Promise.all(uniqueHandles.map(function (h) { return getProductByHandle(h); }));
    var productMap = {};
    for (var j = 0; j < uniqueHandles.length; j++) {
      productMap[uniqueHandles[j]] = productResults[j];
    }

    // Build items and compute compare_at subtotal from product data
    var compareAtSubtotal = 0;
    for (var k = 0; k < cartData.items.length; k++) {
      var element = cartData.items[k];
      var productByHandle = productMap[element.handle];
      if (!productByHandle) continue;

      var cartItem = document.createElement('div');
      var compareAtPriceValue = '';
      cartItem.classList.add('kcp-item', 'cart_popup__item');
      cartItem.dataset.variant = element.variant_id;

      for (var v = 0; v < productByHandle.variants.length; v++) {
        var variant = productByHandle.variants[v];
        if (variant.id == element.variant_id) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareAtPriceValue = moneyFmt.format(variant.compare_at_price / 100);
            compareAtSubtotal += variant.compare_at_price;
          } else {
            compareAtSubtotal += variant.price;
          }
          break;
        }
      }

      // MIRROR OF snippets/cart-popup.liquid. That file's cart.items loop is a
      // first-paint placeholder; this is what a shopper actually sees, because
      // buildCart empties .cart_popup__inner_content on every page load.
      // Change one and you must change the other, in the same commit.
      cartItem.innerHTML =
        // A link, not a div — the thumbnail is the most obvious thing in the row
        // to click and it did nothing. aria-hidden + tabindex -1 because the
        // title below is a link to the same URL, and without them this is a
        // second tab stop announcing the same destination.
        '<a href="' + element.url + '" class="kcp-item__media cart_popup__item_img_wr" aria-hidden="true" tabindex="-1">' +
          '<img src="' + element.image + '" alt="" width="300" height="169" loading="lazy">' +
        '</a>' +
        '<div class="kcp-item__info cart_popup__info">' +
          // product_title, NOT title. /cart.js `title` is "Product - Variant",
          // so using it here printed the variant twice: once in the heading and
          // again on the line below it. The Liquid uses item.product.title.
          '<a href="' + element.url + '" class="kcp-item__title cart_popup__title">' + (element.product_title || element.title) + '</a>' +
          '<div class="kcp-item__meta cart_popup__type">' + (element.variant_title || '') + '</div>' +
          '<div class="kcp-item__prices">' +
            // --now only when there is something to compare against. It is what
            // turns the figure vermilion, and a lone price must stay ink.
            '<span class="kcp-price cart_popup__price' + (compareAtPriceValue ? ' kcp-price--now' : '') + '">' + moneyFmt.format(element.final_line_price / 100) + '</span>' +
            '<span class="kcp-price kcp-price--was cart_popup__price cart_popup__price--compare">' + compareAtPriceValue + '</span>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="kcp-remove cart_popup__remove" aria-label="Remove ' + (element.product_title || element.title) + ' from cart">' +
          '<svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M4.5 0.5V1.333H0.333V3H1.167V13.833C1.167 14.275 1.342 14.699 1.655 15.012C1.967 15.324 2.391 15.5 2.833 15.5H11.167C11.608 15.5 12.032 15.324 12.345 15.012C12.657 14.699 12.833 14.275 12.833 13.833V3H13.667V1.333H9.5V0.5H4.5ZM2.833 3H11.167V13.833H2.833V3ZM4.5 4.667V12.167H6.167V4.667H4.5ZM7.833 4.667V12.167H9.5V4.667H7.833Z" fill="currentColor"/></svg>' +
        '</button>';

      if (cartInnerContent) cartInnerContent.insertAdjacentElement('beforeend', cartItem);
    }

    // Cache and update totals — pass compare_at subtotal computed from product data
    lastCompareAtSubtotal = compareAtSubtotal;
    calculateSum(cartData, compareAtSubtotal);

    // productMap is passed through: it already holds every cart product's id
    // and tags, which is everything the recommendation engine needs.
    loadCartRecommendations(cartData, productMap);
  };

  var addToCart = async function (el) {
    try {
      var cartContent = document.querySelector('.cart-popup-wrapper_content');
      if (cartContent) cartContent.classList.add('--loading');

      var data = { 'id': el.dataset.variant, 'quantity': 1 };
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      await response.json();
      await buildCart(el);

      if (cartContent) cartContent.classList.remove('--loading');

      if (window.innerWidth > 767 && cartDrawer) {
        cartDrawer.classList.add('cart-popup-wrapper--show');
      }

      var submitBtn = document.querySelector('.product-form__cart-submit');
      if (submitBtn) {
        submitBtn.classList.add('submitted');
        submitBtn.disabled = false;
      }

      var arrow = document.querySelector('.site-header__cart_arrow');
      var msg = document.querySelector('.header_message');
      if (arrow) arrow.classList.add('active');
      if (msg) msg.classList.add('active');

      setTimeout(function () {
        if (arrow) arrow.classList.remove('active');
        if (msg) msg.classList.remove('active');
      }, 2000);
    } catch (error) {}
  };

  // compareAtSubtotal: sum of compare_at_price (or price if no compare_at) in cents,
  // computed in buildCart from product data. If not provided, falls back to original_total_price.
  var calculateSum = async function (cartData, compareAtSubtotal) {
    try {
      var subtotalEls = document.querySelectorAll('.cart_popup__bottom_value--subtotal');
      var discountEls = document.querySelectorAll('.cart_popup__bottom_value--discount');
      var totalEls = document.querySelectorAll('.cart_popup__bottom_value--total');

      if (!cartData) cartData = await getCart();

      document.querySelectorAll('.cart_count').forEach(function (el) { el.innerHTML = cartData.item_count; });
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.innerHTML = cartData.item_count; });

      if (cartData.item_count > 0) {
        var subtotalPrice = compareAtSubtotal || lastCompareAtSubtotal || cartData.original_total_price;
        var discountPrice = subtotalPrice - cartData.total_price;

        var subtotalText = moneyFmt.format(subtotalPrice / 100);
        var discountText = discountPrice > 0 ? '-' + moneyFmt.format(discountPrice / 100) : '';
        var totalText = moneyFmt.format(cartData.total_price / 100);

        subtotalEls.forEach(function (el) { el.textContent = subtotalText; });
        // Hide the whole Discounts ROW when there is no discount, rather than
        // writing an empty value into it. It used to render as a label with
        // nothing beside it — a line in the totals block whose only message was
        // that nothing had happened, in the one place every line should mean
        // something. The row is restored the moment a discount applies.
        discountEls.forEach(function (el) {
          el.textContent = discountText;
          var row = el.closest('.kcp-line, .cart_popup__bottom_item, .cart__summary-row');
          if (row) row.hidden = discountPrice <= 0;
        });
        totalEls.forEach(function (el) { el.textContent = totalText; });

        var content = document.querySelector('.cart-popup-wrapper_content');
        var empty = document.querySelector('.cart-popup-wrapper_empty');
        if (content) content.classList.remove('hidden');
        if (empty) empty.classList.add('hidden');
      } else {
        subtotalEls.forEach(function (el) { el.textContent = moneyFmt.format(0); });
        discountEls.forEach(function (el) { el.textContent = ''; });
        totalEls.forEach(function (el) { el.textContent = moneyFmt.format(0); });

        var contentEl = document.querySelector('.cart-popup-wrapper_content');
        var emptyEl = document.querySelector('.cart-popup-wrapper_empty');
        if (contentEl) contentEl.classList.add('hidden');
        if (emptyEl) emptyEl.classList.remove('hidden');
        loadEmptyCartShelf();
      }
    } catch (error) {}
  };

  // ---- Upsell / Cross-sell ----

  // WHAT WAS WRONG, BECAUSE THE SHAPE OF THE FIX FOLLOWS FROM IT
  //
  // This rail used to answer "what is at the top of one hard-coded collection".
  // That is not a question about the cart, so it has the same answer for
  // everybody. UPSELL_COLLECTION was a constant, its response was cached for
  // the page, and both callers rendered items 0 and 1 of it. The cart was read
  // only to drop exact handle matches — and the two products at the top of that
  // collection are in almost nobody's cart, so almost nothing was ever dropped.
  // Every shopper saw Cat Emotes and Chibi Girl Emotes: cart empty, cart full,
  // whatever was in it. Driven against four different carts on the deployed
  // drawer, all four rendered that same pair.
  //
  // /recommendations/products.json is the idiomatic route, and the note this
  // replaces had rejected it for surfacing "sub-products". That was a real
  // observation. Asked about Whisper — an $18 pack — the API returns Whisper
  // Overlays, Whisper Alerts and Whisper Transition as its top three: the three
  // files that ARE the Whisper pack, sold separately. Offering those to someone
  // who just added the pack offers them what they already have.
  //
  // It is worse than that, and this is the part that decides the design. After
  // those three the API returns Y2K Boy, Anime Sky, Osaka, Valhalla, Celestial
  // — other packs, which are SUBSTITUTES for the thing in the cart, under a
  // heading that promises completion. So for a cart holding a pack the API
  // returns only two kinds of thing and both are wrong. It was not rejected for
  // a filterable defect; it is the wrong instrument for that one cart shape.
  //
  // It is the right instrument for the other two. Seeded with a component
  // (whisper-overlays) it returns the parent pack FIRST, which is the best
  // upsell in the store. Seeded with an accessory (cat-emotes) it returns Cat
  // Badges, a chat widget and other emote sets — real complements that would
  // otherwise need a hand-built map.
  //
  // Hence: the API for component and accessory carts, an accessory shelf for
  // pack carts, and in both cases never the thing in the cart and never a part
  // of the thing in the cart.

  // Category is readable from the handle, and the catalogue is strict about it.
  // Counted over all 660 products in /collections/all/products.json:
  // 131 -overlays, 131 -alerts, 130 -transition and 2 -transitions are the
  // components that ship inside a pack; 67 -widget, 17 -decorations, 11 -badges,
  // 11 -emotes and 1 -model are the accessories a pack never contains; the ~160
  // names left over are the packs themselves.
  var COMPONENT_SUFFIXES = ['-overlays', '-alerts', '-transition', '-transitions'];
  var ACCESSORY_SUFFIXES = ['-emotes', '-badges', '-widget', '-widgets', '-decorations', '-model', '-models'];

  // The four collections holding nothing a pack already includes. Which one a
  // given cart draws from is decided by the cart, in accessoryShelf below.
  var ACCESSORY_COLLECTIONS = ['emotes', 'badges', 'twitch-widgets', 'stream-decorations'];

  // An empty cart has nothing to be relevant to, so it gets the flagship
  // category rather than a guess. It used to get 'emotes', under a heading that
  // said "overlays".
  var EMPTY_CART_COLLECTION = 'full-packs';

  // Two beside a filled cart, where the line items are the subject and the rail
  // is an aside. Four in an empty one, where the rail IS the content — see the
  // note on .kcp-empty in snippets/cart-popup.liquid.
  var FILLED_CART_CARDS = 2;
  var EMPTY_CART_CARDS = 4;

  // Per page load. buildCart() runs on every page load, so both of these are
  // read far more often than they are filled.
  var collectionCache = {};
  var recommendationCache = {};

  // Normalize price to cents — /products/x.js and /recommendations/products.json
  // return cents (int), /collections/x/products.json returns dollars (string
  // like "29.00"). Integers pass straight through, so callers never have to
  // know which endpoint a product arrived from.
  function toCents(price) {
    if (typeof price === 'string') return Math.round(parseFloat(price) * 100);
    return price;
  }

  // Titles and URLs both reach the DOM as concatenated HTML. Recommendation
  // URLs carry Shopify's attribution query string, so they ALWAYS contain
  // unescaped ampersands.
  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function hasSuffix(handle, suffixes) {
    for (var i = 0; i < suffixes.length; i++) {
      var s = suffixes[i];
      if (handle.length > s.length && handle.slice(-s.length) === s) return true;
    }
    return false;
  }

  // Get Shopify CDN image at specific size
  function sizedImage(src, size) {
    if (!src) return '';
    // Handle both bare URLs and URLs with query params
    return src.replace(/(\.\w+)(\?|$)/, '_' + size + '$1$2');
  }

  // Three endpoints, three image shapes: /products/x.js and the recommendations
  // API give featured_image as a string, /collections/x/products.json gives no
  // featured_image and an images array of {src} objects, and the recommendations
  // API's own images array holds bare strings.
  function productImage(product) {
    if (product.featured_image) return product.featured_image;
    var first = product.images && product.images[0];
    if (!first) return '';
    return typeof first === 'string' ? first : (first.src || '');
  }

  function renderUpsellCard(product) {
    var variant = product.variants && product.variants[0];
    if (!variant) return '';
    var priceCents = toCents(variant.price);
    var compareCents = toCents(variant.compare_at_price);
    var price = moneyFmt.format(priceCents / 100);
    var compareHtml = '';
    if (compareCents && compareCents > priceCents) {
      compareHtml = '<span class="kcp-upsell__was cart_popup__upsell_compare">' + moneyFmt.format(compareCents / 100) + '</span>';
    }
    var imgSrc = sizedImage(productImage(product), '280x');
    var productUrl = product.url || ('/products/' + product.handle);
    // The upsell card has NO Liquid equivalent — it exists only here. Its
    // classes are styled from the kcp- layer in snippets/cart-popup.liquid.
    // Keep the Add button text-only: the click handler rewrites its label
    // with textContent, which would delete any element inside it.
    return '<div class="kcp-upsell__card cart_popup__upsell_card">' +
      '<a href="' + esc(productUrl) + '" class="kcp-upsell__media cart_popup__upsell_img_link" aria-hidden="true" tabindex="-1">' +
        '<img src="' + esc(imgSrc) + '" alt="" width="280" height="158" loading="lazy">' +
      '</a>' +
      '<div class="kcp-upsell__info cart_popup__upsell_info">' +
        '<a href="' + esc(productUrl) + '" class="kcp-upsell__name cart_popup__upsell_name">' + esc(product.title) + '</a>' +
        '<div class="kcp-upsell__prices cart_popup__upsell_prices"><span>' + price + '</span>' + compareHtml + '</div>' +
      '</div>' +
      '<button type="button" class="kcp-upsell__add cart_popup__upsell_add" data-variant="' + esc(variant.id) + '" aria-label="Add ' + esc(product.title) + ' to cart">Add</button>' +
    '</div>';
  }

  async function fetchCollectionProducts(handle, limit) {
    if (collectionCache[handle]) return collectionCache[handle];
    try {
      var response = await fetch('/collections/' + handle + '/products.json?limit=' + limit);
      var data = await response.json();
      collectionCache[handle] = data.products || [];
    } catch (error) {
      collectionCache[handle] = [];
    }
    return collectionCache[handle];
  }

  async function fetchRecommendations(productId) {
    if (recommendationCache[productId]) return recommendationCache[productId];
    try {
      var response = await fetch('/recommendations/products.json?product_id=' + productId + '&limit=10');
      var data = await response.json();
      recommendationCache[productId] = data.products || [];
    } catch (error) {
      recommendationCache[productId] = [];
    }
    return recommendationCache[productId];
  }

  // The same cart always produces the same shelf, and two different carts
  // almost never produce the same one. It picks the accessory category, and it
  // breaks ties between candidates the tags score equally — without a tiebreak
  // those fall back to collection order, and every such cart lands on the first
  // product in it, which is the whole bug this replaces.
  function cartSeed(handles) {
    var key = handles.slice().sort().join('|');
    var hash = 0;
    for (var i = 0; i < key.length; i++) {
      hash = ((hash << 5) - hash + key.charCodeAt(i)) | 0;
    }
    return Math.abs(hash);
  }

  // Tags beginning with '_' are app bookkeeping — _wf_cus is on most of the
  // catalogue — so they match everything and would score every candidate alike.
  function tagIndex(products) {
    var index = {};
    for (var i = 0; i < products.length; i++) {
      var tags = products[i] && products[i].tags;
      if (!tags) continue;
      for (var j = 0; j < tags.length; j++) {
        var tag = String(tags[j]);
        if (tag.charAt(0) === '_') continue;
        index[tag.toLowerCase()] = true;
      }
    }
    return index;
  }

  function tagOverlap(index, tags) {
    var score = 0;
    if (!tags) return 0;
    for (var i = 0; i < tags.length; i++) {
      if (index[String(tags[i]).toLowerCase()]) score++;
    }
    return score;
  }

  function offerable(product, cartHandles, cartHasPack) {
    var handle = product && product.handle;
    if (!handle) return false;
    if (product.available === false) return false;
    for (var i = 0; i < cartHandles.length; i++) {
      // The thing itself.
      if (handle === cartHandles[i]) return false;
      // A part of the thing. Every component in the catalogue is named
      // <pack>-overlays / -alerts / -transition, so a prefix test is exact.
      if (handle.indexOf(cartHandles[i] + '-') === 0) return false;
    }
    // With a pack in the cart, a component is already inside it and another
    // pack is a substitute for it. Only an accessory is an addition.
    if (cartHasPack && !hasSuffix(handle, ACCESSORY_SUFFIXES)) return false;
    return true;
  }

  function renderShelf(container, wrapper, products) {
    if (products.length === 0) {
      wrapper.classList.remove('cart_popup__upsell--visible');
      container.innerHTML = '';
      return;
    }
    var html = '';
    for (var i = 0; i < products.length; i++) {
      html += renderUpsellCard(products[i]);
    }
    container.innerHTML = html;
    wrapper.classList.add('cart_popup__upsell--visible');
  }

  // Accessories, ranked by how much of the cart's own vocabulary they share.
  // Whisper is tagged Fantasy / RPG / Blue / Green and lands on Viking Emotes;
  // Cute Cats is tagged Cute / Kawaii / Cozy / Orange and lands on Cat Emotes.
  // Where the tags say nothing the seeded rotation decides, so equal candidates
  // still differ between carts instead of all collapsing onto item 0.
  async function accessoryShelf(cartHandles, cartTags, want) {
    var seed = cartSeed(cartHandles);
    var handle = ACCESSORY_COLLECTIONS[seed % ACCESSORY_COLLECTIONS.length];
    var products = await fetchCollectionProducts(handle, 25);
    var scored = [];
    for (var i = 0; i < products.length; i++) {
      // false, not cartHasPack. The category question is already settled here —
      // these came out of an accessory collection — and asking the suffix test
      // again gets the wrong answer for the ones that do not carry a category
      // suffix in their handle. Five of the 25 in twitch-widgets are like that:
      // nexi-ai-streamer, horizontal-event-list and the three stream games,
      // which are the most interesting things in the collection. The suffix set
      // classifies CART items, where a handle is all there is to go on; it is
      // not a membership test for a collection that already knows.
      if (!offerable(products[i], cartHandles, false)) continue;
      scored.push({
        product: products[i],
        score: tagOverlap(cartTags, products[i].tags),
        rotation: (seed + i) % (products.length || 1)
      });
    }
    scored.sort(function (a, b) { return b.score - a.score || a.rotation - b.rotation; });
    return scored.slice(0, want).map(function (entry) { return entry.product; });
  }

  // productMap is buildCart's already-fetched /products/<handle>.js payloads,
  // keyed by handle. It carries the product ids the recommendations API needs
  // and the tags the accessory shelf ranks on, so neither costs a request.
  async function loadCartRecommendations(cartData, productMap) {
    var container = document.querySelector('[data-cart-upsell-products]');
    var wrapper = document.querySelector('[data-cart-upsell]');
    if (!container || !wrapper) return;

    var cartHandles = [];
    for (var i = 0; i < cartData.items.length; i++) {
      var handle = cartData.items[i].handle;
      if (cartHandles.indexOf(handle) === -1) cartHandles.push(handle);
    }
    if (cartHandles.length === 0) {
      renderShelf(container, wrapper, []);
      return;
    }

    var cartProducts = cartHandles.map(function (h) { return productMap[h]; }).filter(Boolean);
    var cartTags = tagIndex(cartProducts);
    var cartHasPack = cartHandles.some(function (h) {
      return !hasSuffix(h, COMPONENT_SUFFIXES) && !hasSuffix(h, ACCESSORY_SUFFIXES);
    });

    var picked = [];
    var seenHandles = {};

    // A pack cart skips the API entirely rather than fetching two responses in
    // order to discard every row of both. See the note at the top of this block.
    if (!cartHasPack) {
      // Highest price first: the dearest line is the strongest statement of
      // what the shopper came for.
      var seeds = cartProducts.slice().sort(function (a, b) {
        return toCents(b.price) - toCents(a.price);
      }).slice(0, 2);

      var responses = await Promise.all(seeds.map(function (p) { return fetchRecommendations(p.id); }));

      // Round-robin, so a two-item cart is answered by both items rather than
      // by whichever one happened to return ten usable rows.
      for (var rank = 0; rank < 10 && picked.length < FILLED_CART_CARDS; rank++) {
        for (var r = 0; r < responses.length && picked.length < FILLED_CART_CARDS; r++) {
          var candidate = responses[r][rank];
          if (!candidate || seenHandles[candidate.handle]) continue;
          if (!offerable(candidate, cartHandles, cartHasPack)) continue;
          seenHandles[candidate.handle] = true;
          picked.push(candidate);
        }
      }
    }

    // Top up rather than replace: a component cart that yielded only its parent
    // pack keeps the parent and gains an accessory beside it.
    if (picked.length < FILLED_CART_CARDS) {
      var shelf = await accessoryShelf(cartHandles, cartTags, FILLED_CART_CARDS);
      for (var s = 0; s < shelf.length && picked.length < FILLED_CART_CARDS; s++) {
        if (seenHandles[shelf[s].handle]) continue;
        seenHandles[shelf[s].handle] = true;
        picked.push(shelf[s]);
      }
    }

    renderShelf(container, wrapper, picked);
  }

  async function loadEmptyCartShelf() {
    var container = document.querySelector('[data-cart-upsell-bestsellers]');
    var wrapper = document.querySelector('[data-cart-upsell-empty]');
    if (!container || !wrapper) return;
    if (container.children.length > 0) return;

    var products = await fetchCollectionProducts(EMPTY_CART_COLLECTION, EMPTY_CART_CARDS);
    renderShelf(container, wrapper, products.slice(0, EMPTY_CART_CARDS));
  }

  // Cart count → kuca class (hides cart icon badge when empty)
  function updateKucaClass() {
    var countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach(function (el) {
      var cartCount = el.innerHTML;
      document.querySelectorAll('.site-header__icon').forEach(function (icon) {
        if (cartCount == 0) {
          icon.classList.add('kuca');
        } else {
          icon.classList.remove('kuca');
        }
      });
    });
  }
  updateKucaClass();

  // Watch for cart count changes via MutationObserver (replaces jQuery DOMSubtreeModified)
  document.querySelectorAll('[data-cart-count]').forEach(function (el) {
    var obs = new MutationObserver(updateKucaClass);
    obs.observe(el, { childList: true, subtree: true, characterData: true });
  });

  var removeItemFromCart = async function (cartItem) {
    try {
      // Start removal animation immediately
      cartItem.classList.add('--removing');
      var data = { 'id': cartItem.dataset.variant, 'quantity': 0 };
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      // Wait for animation, then full rebuild (recalculates compare_at subtotal)
      setTimeout(async function () {
        cartItem.remove();
        var dummyEl = document.querySelector('.product-form__cart-submit') || document.createElement('div');
        await buildCart(dummyEl);
        await checkProductsInCart();
      }, 350);
    } catch (error) {}
  };

  // Exposed globally — theme.js calls checkProductsInCart() on variant changes
  window.checkProductsInCart = async function () {
    var cartProducts = await getCart();
    var submitBtn = document.querySelector('.product-form__cart-submit');
    if (!submitBtn) return;

    var counter = 0;
    cartProducts.items.forEach(function (el) {
      if (el.variant_id == submitBtn.getAttribute('data-variant')) {
        counter++;
      }
    });

    if (counter > 0) {
      submitBtn.classList.add('submitted');
    } else {
      submitBtn.classList.remove('submitted');
    }
    submitBtn.disabled = false;
  };

  // Cart initialization — script is deferred, so DOM is ready
  if (document.querySelector('.template-product')) {
    checkProductsInCart();
  }
  buildCart();

  // Cart event handlers
  on('click', '.product-form__cart-submit', function (e) {
    e.preventDefault();
    if (this.classList.contains('submitted')) {
      if (cartDrawer) cartDrawer.classList.add('cart-popup-wrapper--show');
      return;
    }
    this.disabled = true;
    addToCart(this);
  });

  on('click', '.cart_popup__remove', function () {
    var cartItem = this.closest('.cart_popup__item');
    if (cartItem) removeItemFromCart(cartItem);
  });

  on('click', '.cart_popup__upsell_add', async function () {
    var button = this;
    var variantId = button.dataset.variant;
    button.disabled = true;
    button.textContent = '...';
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      // Full rebuild — ensures compare_at prices, subtotal, and upsell all update correctly
      var dummyEl = document.querySelector('.product-form__cart-submit') || document.createElement('div');
      await buildCart(dummyEl);
      // Show filled cart state
      var content = document.querySelector('.cart-popup-wrapper_content');
      var empty = document.querySelector('.cart-popup-wrapper_empty');
      if (content) content.classList.remove('hidden');
      if (empty) empty.classList.add('hidden');
    } catch (error) {
      button.disabled = false;
      button.textContent = 'Add';
    }
  });

  on('click', '.cart-popup__close', function () {
    if (cartDrawer) cartDrawer.classList.remove('cart-popup-wrapper--show');
  });

  on('click', '.site-header__cart', function () {
    if (cartDrawer) cartDrawer.classList.add('cart-popup-wrapper--show');
    calculateSum();
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.site-header__icon') && !e.target.closest('.cart-popup-wrapper') && !e.target.closest('.product-form__cart-submit')) {
      if (cartDrawer) cartDrawer.classList.remove('cart-popup-wrapper--show');
    }
  });

  on('click', '.header_message_close', function () {
    var msg = document.querySelector('.header_message');
    var arrow = document.querySelector('.site-header__cart_arrow');
    if (msg) msg.classList.remove('active');
    if (arrow) arrow.classList.remove('active');
  });

  // ---- DOM Replicator (kec → dvica) ----
  var kecDiv = document.getElementById('kec');
  var dvicaDiv = document.getElementById('dvica');
  if (kecDiv && dvicaDiv) {
    var replicateObserver = new MutationObserver(function () {
      dvicaDiv.innerHTML = kecDiv.innerHTML;
      syncSavePill();
    });
    replicateObserver.observe(kecDiv, { childList: true, subtree: true });
  }

  // ---- "Save N%" pill ----
  //
  // The pill sits beside "One-time purchase", which is OUTSIDE the price
  // block, so nothing redraws it when the variant changes: theme.js rewrites
  // #kec and the observer above mirrors that into #dvica, and both of those
  // are inside the price. Recomputing here off the same mutation keeps the two
  // in step without a second source of truth for "has the variant changed".
  //
  // Read from ProductJson rather than by parsing the rendered figures. Money
  // strings carry a merchant-configured currency format and the theme also
  // strips ".00" from them, so scraping the DOM would be parsing our own
  // formatting back off the page; the JSON holds integer cents.
  //
  // The markup is server-rendered too, so a correct value is painted before
  // this ever runs and it never flashes the wrong number or appears late.
  function syncSavePill() {
    var pill = document.querySelector('[data-save-pill]');
    if (!pill) return;

    // Prefix match, not the literal id: both carry {{ section.id }}, which is
    // 'product-template' on the Liquid template and a compound id if the JSON
    // template is ever activated.
    var json = document.querySelector('[id^="ProductJson-"]');
    var select = document.querySelector('[id^="ProductSelect-"]');
    if (!json || !select) return;

    var variants;
    try {
      variants = JSON.parse(json.textContent).variants;
    } catch (e) {
      return; // leave the server-rendered value alone rather than blanking it
    }
    if (!variants) return;

    var current = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(select.value)) {
        current = variants[i];
        break;
      }
    }

    var compare = current && current.compare_at_price;
    if (!current || !compare || compare <= current.price) {
      pill.hidden = true;
      return;
    }

    // Off the compare-at, not off the price: 39 down to 19.50 is 50% off.
    var pct = Math.round(((compare - current.price) / compare) * 100);
    if (pct < 1) {
      pill.hidden = true;
      return;
    }
    pill.textContent = 'Save ' + pct + '%';
    pill.hidden = false;
  }

  syncSavePill();

})();
